import { el, mount, unmount } from 'redom';

import DeleteButton from 'generics/components/delete-button';
import SaveButton from 'generics/components/save-button';
import SingleSelectNative from 'generics/components/single-select/native';
import TextInputRow from 'generics/components/text-input-row';

import {
  buildTypeInputConfiguration,
  getDefaultOptionsByType
} from './utilities';

import TextFieldOptionsEditor from './options-editors/text';
import EmailFieldOptionsEditor from './options-editors/email';
import NumberFieldOptionsEditor from './options-editors/number';
import SelectFieldOptionsEditor from './options-editors/select';
import CheckboxGroupFieldOptionsEditor from './options-editors/checkbox-group';
import FileFieldOptionsEditor from './options-editors/file';

import fieldTypes from '../field-types';

const OptionsEditors = {
  [fieldTypes.TEXT]: TextFieldOptionsEditor,
  [fieldTypes.EMAIL]: EmailFieldOptionsEditor,
  [fieldTypes.NUMBER]: NumberFieldOptionsEditor,
  [fieldTypes.TEXT_AREA]: TextFieldOptionsEditor,
  [fieldTypes.SELECT]: SelectFieldOptionsEditor,
  [fieldTypes.CHECKBOX_GROUP]: CheckboxGroupFieldOptionsEditor,
  [fieldTypes.RADIO_BUTTON_GROUP]: CheckboxGroupFieldOptionsEditor,
  [fieldTypes.FILE]: FileFieldOptionsEditor
};

class FieldRowEditor {

  constructor(configuration, dialogConfiguration) {

    this.fieldRowIndex = configuration.fieldRowIndex;
    this.fieldRow = {
      ...configuration.fieldRow,
      options: {
        ...configuration.fieldRow.options
      }
    };
    this.signupForm = configuration.signupForm;
    this.onSave = configuration.onSave;
    this.onDelete = configuration.onDelete;
    this.dialogConfiguration = dialogConfiguration;

    this.typeInput = null;
    this.optionsEditor = null;
    this.fieldOptionsEditorContainer = null;

    this.el = el('div.form-field-row-editor-main', [
      el('h3', 'Update field'),
      this.renderInputsSection(),
      this.renderControlsSection()
    ]);

  }

  renderInputsSection() {

    return el('.form-field-row-editor-inputs-section', [
      this.renderLabelInputRow(),
      this.renderTypeInputRow(),
      this.renderFieldOptionsEditorContainerRow()
    ]);

  }

  renderLabelInputRow() {

    return new TextInputRow({
      label: 'Label',
      placeholder: 'Input label',
      value: this.fieldRow.label,
      onChange: this.handleLabelInputChange.bind(this)
    });

  }

  renderTypeInputRow() {

    const value = this.fieldRow.type;
    const onChange = this.handleTypeChange.bind(this);

    this.typeInput = new SingleSelectNative(buildTypeInputConfiguration(this.signupForm, value, onChange));

    return el('.form-input-row', [
      el('label.field-label', 'Type'),
      this.typeInput
    ]);

  }

  renderFieldOptionsEditorContainerRow() {

    this.fieldOptionsEditorContainer = el('.form-field-row-editor-field-options-editor-container', []);

    this.updateFieldOptionsEditor();

    return this.fieldOptionsEditorContainer;

  }

  renderDeleteButton() {

    const deleteButton = new DeleteButton({
      label: 'Delete',
      onClick: this.handleDeleteButtonClick.bind(this)
    });

    return deleteButton;

  }

  renderSaveButton() {

    const saveButton = new SaveButton({
      label: 'Save',
      onClick: this.handleSaveButtonClick.bind(this)
    });

    return saveButton;

  }

  renderControlsSection() {

    return el('.form-field-row-editor-controls-section', [
      this.renderDeleteButton(),
      this.renderSaveButton()
    ]);

  }

  updateFieldOptionsEditor() {

    const OptionsEditor = OptionsEditors[this.fieldRow.type];
    const optionsEditor = new OptionsEditor({
      fieldRow: this.fieldRow,
      onChange: this.handleFieldOptionsChange.bind(this)
    });

    if (this.optionsEditor !== null) {
      unmount(this.fieldOptionsEditorContainer, this.optionsEditor);
    }

    this.optionsEditor = optionsEditor;

    mount(this.fieldOptionsEditorContainer, this.optionsEditor);

  }

  handleFieldOptionsChange(fieldOptions) {

    this.fieldRow.options = fieldOptions;

  }

  handleLabelInputChange(event, label) {

    this.fieldRow.label = label;

  }

  handleTypeChange({ values: [type] }) {

    this.fieldRow.type = type;
    this.fieldRow.options = getDefaultOptionsByType(type);

    this.updateFieldOptionsEditor();
  }

  handleDeleteButtonClick() {

    this.onDelete(this.fieldRowIndex, this.dialogConfiguration);

  }

  handleSaveButtonClick() {

    this.onSave(this.fieldRowIndex, this.fieldRow, this.dialogConfiguration);

  }

}

export default FieldRowEditor;